export { default } from "./NewProductAddedNotification";
